module.exports = __webpack_public_path__ + "img/full4-min.b47c292c.png";